import switchFunc from 'lib/switchFunc'

export const TOUR_V2_ROOM_TYPE_COPY: Record<Tours.V2OfferRoomType, string> = {
  single: 'Single room',
  twin: 'Twin room',
  twinShare: 'Twin share',
  triple: 'Triple room',
  tripleShare: 'Triple share',
  quad: 'Quad room',
  quadShare: 'Quad share',
  multiShare: 'Multi share',
}

const formatRoomType = switchFunc(TOUR_V2_ROOM_TYPE_COPY, null)

export default formatRoomType
